<template>
  <transition name="fade">
    <div class="spinner-wrapper">
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Spinner"
};
</script>

<style>
.spinner-wrapper {
  align-items: center;
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 20vh;
  width: 100%;
  height: 75vh;
}

.spinner {
  margin: 100px auto;
  width: 75px;
  height: 75px;
  text-align: center;
  font-size: 10px;
}

.spinner > div {
  background-color: var(--michigan-blue);
  height: 100%;
  width: 6px;
  display: inline-block;
  margin-left: 0.25rem;
  margin-right: 0.25rem;

  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@keyframes sk-stretchdelay {
  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
    -webkit-transform: scaleY(1);
  }
}
</style>
